import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_help_sticky_options = _resolveComponent("help-sticky-options");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_page_sticky = _resolveComponent("q-page-sticky");
    return (_ctx.isMounted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _withDirectives(_createVNode(_component_q_page_sticky, {
                position: "bottom-right",
                offset: [18, 18],
                class: "z-20"
            }, {
                default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_q_btn, {
                        rounded: "",
                        "no-caps": "",
                        label: "Support",
                        "aria-label": "Support",
                        "icon-right": "support_agent",
                        color: "primary hide-lt-lg"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_help_sticky_options)
                        ]),
                        _: 1
                    }, 512), [
                        [_vShow, _ctx.showFAB && _ctx.permaFAB]
                    ]),
                    _withDirectives(_createVNode(_component_q_btn, {
                        round: "",
                        "no-caps": "",
                        icon: "support_agent",
                        "aria-label": "Support",
                        color: "primary",
                        class: "hide-gt-lg"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_help_sticky_options)
                        ]),
                        _: 1
                    }, 512), [
                        [_vShow, _ctx.showFAB && _ctx.permaFAB]
                    ])
                ]),
                _: 1
            }, 512), [
                [_vShow, _ctx.isMounted]
            ])
        ]))
        : _createCommentVNode("", true);
}
